import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useSetState } from "Helpers/Hooks";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import OptimizeGalvanize from "../OptimizeGalvanize/OptimizeGalvanize";
import OptimizeProfile from "../OptimizeProfile/OptimizeProfile";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import { CONSTRUCTION_RESULT } from "Stores/actionTypes";
import { useDispatch, useSelector } from "react-redux";

export default function Optimize() {
  const dispatch = useDispatch();
  const [optimizePage, setOptimizePage] = useState(1);
  const { constructionResult } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
  }));
  const [controls, setControls] = useSetState({
    isBeforeOptimal: {
      type: "checkbox",
      value: { value: false, key: "manageCountBeforeOptimize" },
      items: [{ value: false, key: "manageCountBeforeOptimize" }],
    },
    action: {
      type: "radio",
      value: { value: 1, key: "behinehSaziProfile" },
      items: [
        { value: 1, key: "behinehSaziProfile" },
        { value: 2, key: "behinehSaziGalvanize" },
      ],
    },
  });

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setOptimizePage(value.value);
  };

  const onClear = () => {
    setOptimizePage(1);
    setControls({
      action: {
        value: { value: 1, key: "OptimizeProfile" },
      },
    });
    setControls({
      isBeforeOptimal: {
        value: {
          value: constructionResult.isBeforeOptimal,
          key: "isBeforeOptimal",
        },
        items: [
          {
            value: constructionResult.isBeforeOptimal,
            key: "isBeforeOptimal",
          },
        ],
      },
    });
  };

  useEffect(() => {
    onClear();
  }, []);

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    const key = items[index].key;
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        [key]: e.currentTarget.checked,
      },
    });
  };

  return (
    <>
      <Grid container className="p-3">
        <Grid container spacing={2} className="mb-2">
          {Object.keys(controls).map((key, index) => {
            return (
              <Grid item>
                {controls[key].type === "checkbox" && (
                  <MuiCheckBoxGroup
                    name={key}
                    value={controls[key].value}
                    items={controls[key].items}
                    onChange={onChangeCheckbox}
                    translate={true}
                    className="horizontalCheckbox"
                  />
                )}
                {controls[key].type === "radio" && (
                  <MuiRadioGroup
                    name={key}
                    value={controls[key].value}
                    items={controls[key].items}
                    onChange={onChangeRadio}
                    translate={true}
                    className="horizontalRadio"
                  />
                )}
              </Grid>
            );
          })}
        </Grid>

        <Grid item xs={12} className="border-top border-bottom pb-2">
          {optimizePage === 1 ? <OptimizeProfile /> : <OptimizeGalvanize />}
        </Grid>
      </Grid>
    </>
  );
}
